import { ReactNode } from "react";
import "./GlobalStyles.scss";

function GlobalStyles({ children }: { children: ReactNode }) {
  return <>{children}</>;
}

export default GlobalStyles;
